import Nanobus from "nanobus";

type Events = {
  unAuthenticatedCloudFunctionError: () => void;
};

export const eventBus = new Nanobus<Events>("global");
